import React from "react";
import TeamLogo from "../sport/components/TeamLogo";

export default function SpinningDisplay({
  currentTeam,
  spinMode,
  spinDisplay,
}) {
  if (!spinDisplay) return null;

  const fixClub = spinMode === "year";
  const fixSeason = spinMode === "team";

  const showClub = fixClub ? currentTeam.club : spinDisplay.club;
  const showSeason = fixSeason ? currentTeam.season : spinDisplay.season;
  // eslint-disable-next-line no-unused-vars
  const showFifa = fixSeason
    ? currentTeam.fifaEdition
    : spinDisplay.fifaEdition;
  const showColor = fixClub
    ? currentTeam.primary || "#10b981"
    : spinDisplay.primary || "#10b981";

  const modeLabel =
    spinMode === "team"
      ? "Respinning team"
      : spinMode === "year"
        ? "Respinning year"
        : "Spinning";

  return (
    <div className="flex flex-col h-full min-h-0">
      <div
        className="rounded-2xl bg-zinc-900/50 border border-zinc-800 p-5 border-l-[3px] shrink-0
                   ring-1 ring-emerald-500/30 shadow-lg shadow-emerald-500/20
                   transition-colors"
        style={{ borderLeftColor: showColor }}
      >
        <div className="flex items-center gap-3">
          <TeamLogo club={showClub} size={36} />
          <h2
            className={`text-xl font-bold truncate transition-colors duration-75
      ${fixClub ? "text-zinc-100" : "text-emerald-300"}`}
          >
            {showClub}
          </h2>
        </div>
        <div className="text-sm mt-1 flex items-center gap-2">
          <span
            className={`font-semibold transition-colors duration-75
              ${fixSeason ? "text-zinc-400" : "text-emerald-300"}`}
          >
            {showSeason}
          </span>
          {/* <span className="text-zinc-700">·</span>
          <span
            className={`transition-colors duration-75
              ${fixSeason ? "text-zinc-400" : "text-emerald-300"}`}
          >
            {showFifa}
          </span> */}
        </div>
      </div>

      <div className="flex-1 grid place-items-center">
        <div className="text-zinc-500 text-xs uppercase tracking-[0.25em] animate-pulse">
          {modeLabel}…
        </div>
      </div>
    </div>
  );
}
